import { Http } from '@mygpt/app/http';

export interface EditMembersParams {
  ai_id?: string;
  user_ids: string[];
  gbase_user_ids?: string[];
  ai_type?: string;
  resource_id?: string;
  resource_type?: string; // dataset | robot
}

/**
 * 添加协作者
 * @param params
 * @returns
 */
export const addMembersService = (params: EditMembersParams) => {
  const { post } = Http.use();
  return post(`/users/members`, { req: [params] });
};
